const Toggle = () => {
  const items = Array.from(document.querySelectorAll(".toggle"));

  if (items.length > 0) {
    items.forEach((item) => {
      const opener = item.querySelector(".toggle__opener");

      opener.addEventListener("click", (e) => {
        e.preventDefault();
        item.classList.toggle("open");
      });
    });
  }
};

export default Toggle;
